import React from 'react'
import { useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { Container, Information, Title } from './styles'

export const Error404: React.FC = () => {
	const intl = useIntl()
	return (
		<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
			<Container>
				<Title>404</Title>
				<Information>
					<p>{intl.formatMessage({ id: 'Página não encontrada' })}</p>
				</Information>
			</Container>
		</div>
	)
}